import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Filters from "@store/Components/Icons/Filters";
import { COMMON } from "@store/theme/design";
import { mediaOptions } from "@store/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    primaryButtonLabel: string;
    secondaryButtonLabel?: string;
    onPrimaryButtonClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onSecondaryButtonClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    extendedStyles?: StoreHistoryPageMobileButtonsStyles;
}

export interface StoreHistoryPageMobileButtonsStyles {
    container?: InjectableCss;
    primaryButton?: ButtonPresentationProps;
    secondaryButton?: ButtonPresentationProps;
}

export const storeHistoryPageMobileButtonsStyles: StoreHistoryPageMobileButtonsStyles = {
    container: {
        css: css`
            display: flex;
            position: relative;
            justify-content: center;
            background-color: ${getColor("common.accent")};
            margin-left: -${COMMON.spacing.side[0]};
            margin-right: -${COMMON.spacing.side[0]};
            padding: 1.5em ${COMMON.spacing.side[0]};

            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [
                        { values: [null, `-${COMMON.spacing.side[1]}`, "0"], properties: ["margin-left", "margin-right"]},
                        { values: [null, `1.5em ${COMMON.spacing.side[1]}`, "0 0 1em"], properties: ["padding"]},
                        { values: [null, null, null, "none"], properties: ["display"]},
                        { values: [null, null, "space-between"], properties: ["justify-content"]},
                        { values: [null, null, "transparent"], properties: ["background-color"]},
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    primaryButton: {
        variant: "primary",
        sizeVariant: "large",
        icon: {
            src: Filters,
            position: "right",
        },
    },
    secondaryButton: {
        variant: "tertiary",
        sizeVariant: "large",
        css: css`
            margin-left: 1.5em;
        `,
    },
};

const StoreHistoryPageMobileButtons = ({ 
    primaryButtonLabel,
    secondaryButtonLabel,
    onPrimaryButtonClick,
    onSecondaryButtonClick,
    extendedStyles,
}: OwnProps) => {
    const [styles] = useState(() => mergeToNew(storeHistoryPageMobileButtonsStyles, extendedStyles));

    if (!primaryButtonLabel || !onPrimaryButtonClick) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container}>
            <Button 
                {...styles.primaryButton}
                onClick={onPrimaryButtonClick}
            >
                {primaryButtonLabel}
            </Button>
            {secondaryButtonLabel && onSecondaryButtonClick ? (
                <Button 
                    {...styles.secondaryButton}
                    onClick={onSecondaryButtonClick}
                >
                    {secondaryButtonLabel}
                </Button>
            ) : null}
        </StyledWrapper>
    );
};

export default StoreHistoryPageMobileButtons;
